export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'https://rc-api.sky-hawk.io/api/v3',
  chargebee: 'picapd',
  cookieDomain: 'rc-manage.sky-hawk.io',
  googleMapsApiUrl: 'https://maps.googleapis.com/maps/api',
  googleApiKey: 'AIzaSyB5QP1a0OZleIqskik3J6WEtGwTLRcJiVA',
  recurlyKey: 'ewr1-9iR5ON60UNkm0SSLp0wyAN',
  appVersion: require('../../package.json').version + '-stage',
  mapViewerBaseUrl: 'https://mapview-stage.sky-hawk.io/'
};
